var _path, _circle, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5C15.5 6.14611 14.7553 7.25936 13.3919 8.11154C12.0354 8.9593 10.1304 9.5 8 9.5C5.86958 9.5 3.96457 8.9593 2.60815 8.11154C1.24467 7.25936 0.5 6.14611 0.5 5C0.5 3.85389 1.24467 2.74064 2.60815 1.88847C3.96457 1.0407 5.86958 0.5 8 0.5C10.1304 0.5 12.0354 1.0407 13.3919 1.88847C14.7553 2.74064 15.5 3.85389 15.5 5Z",
    stroke: "#B4C0CF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5,
    r: 1.5,
    stroke: "#B4C0CF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.282168,
    y: 8.97484,
    width: 17.3093,
    height: 0.9,
    rx: 0.45,
    transform: "rotate(-30 0.282168 8.97484)",
    fill: "#B4C0CF",
    stroke: "#B4C0CF",
    strokeWidth: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye_close.9adbb519971d3736ab203160b323bdf0.svg";
export { ForwardRef as ReactComponent };